module.exports = __webpack_public_path__ + "static/media/elastic.ec035f6e.png";